import { createRoute } from '@tanstack/react-router';
import { groupParentRoute } from 'pages/group/groupParentRoute';
import { pageResetMiddleWare, zodPage, zodPathParamId } from 'routes/routeUtils';
import { z } from 'zod';

export const groupPharmacyListRoute = createRoute({
  getParentRoute: () => groupParentRoute,
  path: '/pharmacy_lists/$id',
  params: z.object({ id: zodPathParamId }),
  validateSearch: z.object({
    query: z.string().optional(),
    page: zodPage,
  }),
  search: { middlewares: [pageResetMiddleWare] },
}).lazy(() =>
  import('pages/group/PharmacyLists/PharmacyListPage/PharmacyListPage').then((d) => d.Route)
);
